import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { GET_LINKABLES_QUERY, GetLinkablesResponse, LINK_ENTITIES_MUTATION, LinkEntitiesResponse, UNLINK_ENTITIES_MUTATION } from './graphql';

import { ApolloService } from '../../apollo.service';
import { Linkable, LinkableImpl } from '../../../entities/entityLink/linkable';
import { LinkableFilter } from '../../../entities/entityLink/linkableFilter';
import { EntityLinkInput } from '../../../entities/entityLink/entityLinkInput';
import { EntityLink } from '../../../entities/entityLink/entityLink';

/**
 * The groups service.
 */
@Injectable()
export class LinkableService {
  constructor(
    private apolloService: ApolloService,
  ) {
  }

  public getLinkables(linkableFilter: LinkableFilter): Observable<Linkable[]> {
    return this.apolloService.query<GetLinkablesResponse>(GET_LINKABLES_QUERY, {
      filter: linkableFilter
    })
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( LinkableImpl.createLinkables(result.data.getLinkables));
        })
      );
  }

  public linkEntities(input: EntityLinkInput): Observable<EntityLink> {
    return this.apolloService.mutateObservable(LINK_ENTITIES_MUTATION, {
      input: input
    })
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( new EntityLink(result.data.linkEntities));
        })
      );
  }

  public unlinkEntities(entityLinkId: string): Observable<Boolean> {
    return this.apolloService.mutateObservable(UNLINK_ENTITIES_MUTATION, {
      entityLinkId: entityLinkId
    })
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( result.data.unlinkEntities );
        })
      );
  }
}
